import { render } from "./RowProposal.vue?vue&type=template&id=3afbd5c1"
import script from "./RowProposal.vue?vue&type=script&lang=js"
export * from "./RowProposal.vue?vue&type=script&lang=js"
script.render = render

export default script